import { render, staticRenderFns } from "./chaptertest.vue?vue&type=template&id=b13800f0&scoped=true&"
import script from "./chaptertest.vue?vue&type=script&lang=js&"
export * from "./chaptertest.vue?vue&type=script&lang=js&"
import style0 from "./chaptertest.vue?vue&type=style&index=0&id=b13800f0&lang=scss&scoped=true&"
import style1 from "./chaptertest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13800f0",
  null
  
)

export default component.exports